import { ReactNode, useState } from 'react';
import { Button, ScrollView, View  } from 'native-base';
import { Caption, H2 } from './Typography';
import { useI18n } from '@springbig/shared';
import { SpIcon } from '~/shared/Icon';
import Section from './Section';
import { useGeneralStyles, useMenuStyles } from './styles';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type NoDataViewProps = {
    callback: () => void;
    title: string;
    message: string;
    isLoading: boolean
    iconName: IconProp;
    header?: ReactNode;
    flexGrow?: number;
}

export const NoDataPlaceholder = ({ callback, title, message, isLoading, iconName, header, flexGrow = 1 }: NoDataViewProps) => {

    const [disabled, setDisabled] = useState(false);
    const {
        text,
        button_background,
        button_text
    } = useGeneralStyles();
    const { t } = useI18n();

    const handleCallback = () => {

        if (!disabled) {
            callback();
        }

        setDisabled(true);

        setTimeout(() => {

            setDisabled(false);
        }, 3 * 60 * 1000);
    };

    let label = t('common.refresh');

    if (disabled) {
        label = t('common.refreshed');
    }

    if (isLoading) {
        label = t('common.fetching');
    }
    const {
        card_background,
        icon
    } = useMenuStyles();


    return (<Section h={"100%"}>
        <ScrollView contentContainerStyle={{ flexGrow: flexGrow, justifyContent: 'center' }}>
            {header}
            <View
                mb={16}
                my={flexGrow ? 0 : "15%"}
                w={"60%"}
                px={4}
                py={8}
                alignItems={"center"}
                bg={card_background}
                borderColor={"#979797"}
                borderWidth={1}
                borderRadius={12}
                shadow={1}
                style={{shadowOffset: {width: 2, height: 4}, shawdowBlur: 4}}
                alignSelf={'center'}
            >
                <View
                    size={200}
                    borderRadius={100}
                    background={icon}
                    alignItems={"center"}
                    justifyContent={"space-around"}
                    shadow={1}
                    style={{shadowOffset: {width: 0, height: 4}, shawdowBlur: 4}}
                >
                    <SpIcon icon={iconName} size={115} color={"white"} />
                </View>
                <H2 color={text} fontWeight={"500"}>
                    {title}
                </H2>
                <Caption color={text} fontWeight={"light"} textAlign={"center"} mb={4}>
                    {message}
                </Caption>
                <Button
                    w={'100%'}
                    borderRadius={12}
                    bg={button_background}
                    _text={{
                        color: button_text,
                    }}
                    _hover={{
                        bg: button_background
                    }}
                    onPress={handleCallback}
                    isDisabled={isLoading || disabled}
                >
                    {label}
                </Button>
            </View>
        </ScrollView>
    </Section>);
      
};

